import { useState } from 'react';
import { ContentHubStyle3 } from '../ContentHubTeaser.styles';
import { ContentHubTeaserCard } from '../../../molecules/ContentHubTeaserCard';
import ShowMoreButton from '../../../molecules/ShowMoreButton/ShowMoreButton';
import ContentHubTeaserCardWrapperContainer from './ContentHubTeaserCardWrapper.styles';

const MIN_TEASERS = 3;
const NEXT_TEASERS = 3;

/**
 * @param {ContentHubTeaserCardWrapperProps} props
 * @returns {React.ReactElement} The rendered component
 */
const ContentHubTeaserCardWrapper = ({ teasers, isContentHubCategoryPage }) => {
  const [currentTeasers, setCurrentTeasers] = useState(
    teasers.slice(0, MIN_TEASERS),
  );
  const [showMore, setShowMore] = useState(teasers.length > MIN_TEASERS);

  const showMoreCallback = () => {
    const newTeaserCount =
      currentTeasers.length + NEXT_TEASERS > teasers.length
        ? teasers.length
        : currentTeasers.length + NEXT_TEASERS;
    if (newTeaserCount < teasers.length) {
      setCurrentTeasers(teasers.slice(0, newTeaserCount));
    } else {
      setCurrentTeasers(teasers);
      setShowMore(false);
    }
  };

  return (
    <ContentHubTeaserCardWrapperContainer>
      <ContentHubStyle3>
        {currentTeasers.map((teaser) => (
          <ContentHubTeaserCard
            key={teaser.id}
            format={'square'}
            {...teaser}
            isContentHubCategoryPage={isContentHubCategoryPage}
          />
        ))}
      </ContentHubStyle3>
      <ShowMoreButton showMore={showMore} showMoreCallback={showMoreCallback} />
    </ContentHubTeaserCardWrapperContainer>
  );
};

export default ContentHubTeaserCardWrapper;
